module.exports = __webpack_public_path__ + "static/media/send.ec214033.svg";